import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import { getAnalytics } from 'firebase/analytics';
import { getFunctions, httpsCallable } from 'firebase/functions';

const firebaseConfig = {
  apiKey: "AIzaSyBm4c9T-FXAEJgEZWExrN5XnT7VFt8lIGY",
  authDomain: "teniso-uzsiemimai.firebaseapp.com",
  projectId: "teniso-uzsiemimai",
  storageBucket: "teniso-uzsiemimai.firebasestorage.app",
  messagingSenderId: "224002461198",
  appId: "1:224002461198:web:704350ee92d9eb2af0b65f",
  measurementId: "G-KV274WGR20"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);
export { httpsCallable };

// Initialize Analytics (only in browser environment)
let analytics = null;
if (typeof window !== 'undefined') {
  try {
    analytics = getAnalytics(app);
  } catch (error) {
    console.log('Analytics not available:', error);
  }
}

export { analytics };
export default app; 